import API from 'app/utils/apiClient';

import { toParams } from 'app/utils/url';

const getComments = (
  objectType,
  objectId,
  type = 'general',
  page = 1,
  perPage = 20,
  formType = null
) => {
  const params = toParams({
    objectType,
    objectId,
    type,
    page,
    perPage,
    ...(formType ? { formType } : {}),
  });
  return API.get(`/comments/?${params}`);
};

const getComment = (id) => API.get(`/comments/${id}/`);

const postComment = (content, objectId, objectType = 'episode') =>
  API.post('/comments/', {
    content,
    objectId,
    objectType,
  });

const deleteComment = (commentId) => API.delete(`/comments/${commentId}/`);

const hideComment = (commentId) => API.post(`/comments/${commentId}/hidden/`);

const likeComment = (commentId) => API.post(`/comments/${commentId}/like/`);

const fixComment = (commentId, source) =>
  API.post(`/comments/${commentId}/fix/`, { source });

const unfixComment = (commentId, source) =>
  API.post(`/comments/${commentId}/unfix/`, { source });

export default {
  getComments,
  getComment,
  postComment,
  deleteComment,
  hideComment,
  likeComment,
  fixComment,
  unfixComment,
};



// WEBPACK FOOTER //
// ./src/app/apis/comment.js